import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
})
export class Footer {
  constructor(
    private route: Router,
    ) {}
goToForfaitList(operator:any){
  this.route.navigate(['/forfaits-mobile-'+operator]);
}
}
